import { LOADING, DATA, DATES } from './ProcessImprovementActions';
import { DASHBOARD_ANALYSIS_DATA } from '../App/AppActions';

const INITIAL_STATE = { 
  ctAnalysis: {},
  ctAnalysisLoading: true,
  wipAgeAnalysis: {},
  wipAgeAnalysisLoading: true,
  wipAnalysis: {},
  wipAnalysisLoading: true,
  ctbAnalysis: {},
  ctbAnalysisLoading: true,
  thAnalysis: {},
  thAnalysisLoading: true,
  feAnalysis: {},
  feAnalysisLoading: true
};

const ProcessImprovementReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING: {
      return {
        ...state,  
        analysisRunning: action.analysisRunning,     
        ctAnalysisLoading: action.analysisRunning,
        ctbAnalysisLoading: action.analysisRunning,
        wipAnalysisLoading: action.analysisRunning,
        wipAgeAnalysisLoading: action.analysisRunning,
        thAnalysisLoading: action.analysisRunning,
        feAnalysisLoading: action.analysisRunning
      };
    }
    case DATA: {
      return {
        ...state,
        [action.chart]: action.data,
        [`${action.chart}Loading`]: false
      };
    }   
    case DATES: {
      return {
        ...state,
        analysisDates: action.data
      };
    }
    case DASHBOARD_ANALYSIS_DATA: {
      return {
        ...state,
        ctAnalysis: null,
        wipAgeAnalysis: null,
        wipAnalysis: null,
        ctbAnalysis: null,
        thAnalysis: null,
        feAnalysis: null,
      };
    }
    default:
      return state;
  }
};

export default ProcessImprovementReducer;
